<!-- ----------------------------------------------- -->
<template>
  <v-card flat class="info-content">
    <v-list class="pa-0" v-for="(info, index) in information" :key="index">
      <v-list-group class="pt-1 pb-1" no-action>
        <template v-slot:activator>
          <v-list-item class="pa-0">
            <v-list-item-content class="pa-0" style="align-self: center;">
              <v-list-item-title class="info-title">
                <span
                  class="info-status"
                  :style="setInfoColorBySummaryCode(info.summaryCode)"
                >
                  {{ infoConfig.summaryCode[info.summaryCode] }}
                </span>
                <span class="ml-4">{{
                  formatDateNonNull(info.announceTime)
                }}</span>
              </v-list-item-title>
              <v-list-item-action-text>
                <span>{{ info.summary }}</span>
              </v-list-item-action-text>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item three-line class="pl-4">
          <v-list-item-content>
            <v-list-item-subtitle>
              <v-row class="ma-0 info-detail">{{ info.detail }}</v-row>
            </v-list-item-subtitle>
            <v-list-item-action-text
              v-if="checkString(info.cameraId)"
              class="mt-2 info-link"
              @click="
                routerCamera(
                  info.cameraSysId,
                  info.cameraScamId,
                  info.cameraOwnCd,
                  info.cameraSysCamId
                )
              "
              >【参照カメラ】{{ info.cameraNm }}</v-list-item-action-text
            >
            <v-list-item-action-text
              v-if="checkString(info.upObsCd)"
              class="mt-2 info-link"
              @click="
                routerTm(info.upObsOfcCd, info.upObsItmkndCd, info.upObsCd)
              "
              >【代替観測所】{{ info.upObsNm }}</v-list-item-action-text
            >
            <v-list-item-action
              v-if="checkString(info.infoManageCode)"
              class="ma-2"
            >
              <v-btn
                outlined
                small
                color="success"
                class="info-button"
                @click="linkUrl(info.infoManageCode)"
              >
                <v-icon left>link</v-icon>
                <span>{{ text.detail }}</span>
              </v-btn>
            </v-list-item-action>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-divider></v-divider>
    </v-list>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 地図画面 MB用お知らせカード
 * MapInfo.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
import Util from "./../../lib/util.js";
export default {
  name: "map-mb-info",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        infoTitle: "お知らせ",
        detail: "詳細",
        upobs: "上流観測所",
        cctv: "CCTVカメラ",
      },
    };
  },
  /** 算出部 */
  computed: {
    /** お知らせ設定情報 */
    infoConfig: {
      get() {
        return this.$store.state.info.informationConfig;
      },
    },
    /** お知らせ情報 */
    information: {
      get() {
        return this.$store.state.map.information;
      },
    },
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** 観測所選択 */
    selectedTm: {
      get() {
        return this.$store.state.Telemeter.selectedTm;
      },
    },
    /** モード */
    isPcMode: {
      get() {
        return this.$store.state.app.mode == "pc";
      },
    },
  },
  /** メソッド */
  methods: {
    /** お知らせ情報を閉じる */
    closeInfo() {
      this.$store.commit("map/hideInfoRw");
    },
    linkUrl(infoManageCd) {
      this.routerPushMbInfoDetail("/mb/info/detail", infoManageCd);
      this.$store.commit("map/hideInfoRw");
    },
    /** カメラ個別観測所へ遷移 */
    routerCamera(sysId, scamId, ownCd, sysCamId) {
      let itmkndCd = 100;
      if (sysId == 1) {
        itmkndCd = 200;
      }
      // カメラの情報をストアに格納
      this.$store.commit("Telemeter/setSelectedTmParamScam", {
        itmkndCd: itmkndCd,
        scamId: scamId,
        ownCd: ownCd,
        sysCamId: sysCamId,
      });
      // カメラ個別観測所へ遷移
      this.routerPushTmScam("/mb/tm");
    },
    /** 代替先の個別観測所へ遷移 */
    routerTm(ofcCd, itmKndCd, obsCd) {
      // 観測所の情報をストアに格納
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: ofcCd,
        itmkndCd: itmKndCd,
        obsCd: obsCd,
      });
      // 個別観測所へ遷移
      this.routerPushTm("/mb/tm");
    },
    checkString(str) {
      if (str == null || str == "") {
        return false;
      }
      return true;
    },
    /** 日付フォーマット */
    formatDateNonNull(val1) {
      return val1 == null ? "" : Util.formatDate24(val1);
    },
    /** summaryCodeでお知らせボタンを着色 */
    setInfoColorBySummaryCode(summaryCode) {
      if (this.infoConfig.titleSummaryCode !== undefined) {
        if (this.infoConfig.titleSummaryCode[summaryCode] !== undefined) {
          return {
            backgroundColor: this.infoConfig.titleSummaryCode[summaryCode].backGroundColor,
            color: this.infoConfig.titleSummaryCode[summaryCode].textColor
          }
        } else {
          // 設定ファイルにないsummaryCodeの場合、その他(summaryCode=5で着色)
          const code = 5;
          return {
            backgroundColor: this.infoConfig.titleSummaryCode[code].backGroundColor,
            color: this.infoConfig.titleSummaryCode[code].textColor
          }
        }
      } else {
        // 設定ファイルにtitleSummaryCodeが無い場合
        return {
          backgroundColor: "#ffffff",
          color: "#000000"
        }
      }
    },
  },
  /** 監視部 */
  watch: {
    content() {
      // 観測所画面から離れた場合は閉じる
      this.$store.commit("map/hideInfoRw");
    },
    selectedTm() {
      // 観測所選択が変更された場合は閉じる
      this.$store.commit("map/hideInfoRw");
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
@import "./../../scss/color.scss";

.info-content {
  .info-title {
    font-size: 0.75rem;
    white-space: normal;
    .info-status {
      padding: 4px 8px 4px 8px;
      border-radius: 8px;
      display: inline-block;
    }
  }
  .info-button {
    width: 80px;
  }
  .info-detail {
    font-size: 0.75rem;
    white-space: pre-wrap;
  }
  // リンク
  .info-link {
    font-size: 0.75rem;
    color: #4169e1;
    cursor: pointer;
  }
  // リンクホバー時
  .info-link:hover {
    text-decoration: underline;
  }
}
</style>
